module.exports = __webpack_public_path__ + "static/media/WalletQRcode.b80ed4ac.png";